export default {
    routeChange: false,
}
